import React, {Fragment} from "react"
import useModalAddUser from "root/Modals/AddUser/useModalAddUser";
import WieldySidebarSection from "root/Wieldy/Sidebar/WieldySidebarSection";
import WieldySidebarClick from "root/Wieldy/Sidebar/WieldySidebarClick";
import {UserTypes} from "root/DataFunctions/Constants";

const MyContributorsSubmenu = (props ) =>
{
    // Open add resource modal
    const [renderAddUserModal, showAddUserModal] = useModalAddUser((result) =>
    {
        if (result === 'saved')
        {
            location.replace(location.pathname);
        }
    })

    const clickHandler = (event) =>
    {
        showAddUserModal(null, 'create', UserTypes.OTHER, false);
    }

    const myContributorsSubmenu =() =>{
        return(
            <WieldySidebarSection title='New Contributor' >
                    <WieldySidebarClick modal={(event) => clickHandler(event)} title='Contributor' iconName='icon-add-circle' iconSize='icon-xl' keyName='root1' key='c1'/>
            </WieldySidebarSection>
        )
    }

    return (
        <Fragment>
            { myContributorsSubmenu ()}
            {renderAddUserModal(props)}
        </Fragment>
    )
}

export default MyContributorsSubmenu ;